module.exports = __webpack_public_path__ + "img/官网-证书-信息化平台ios.75816a91.png";